import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

/**
 * isFullAdmin: replica a lógica de MainListItems (admin/super têm bypass total).
 * Source de verdade ainda é o backend (isAdminOrSuper nas rotas REST).
 * Esta verificação client-side é defesa em profundidade contra acesso por URL direta.
 */
const isFullAdmin = (user) => {
	if (!user) return false;
	if (user.super) return true;
	if (user.profile === "admin") return true;
	return false;
};

/**
 * Verifica se o usuário tem uma permissão de menu específica.
 * Match com `user.menuPermissions` (array de strings vindo do backend).
 */
const hasMenuPermission = (user, permissionKey) => {
	if (!permissionKey) return true;
	if (isFullAdmin(user)) return true;
	const permissions = user?.menuPermissions || [];
	return permissions.includes(permissionKey);
};

const Route = ({ component: Component, isPrivate = false, requiredPermission = null, ...rest }) => {
	const { isAuth, loading, user } = useContext(AuthContext);

	if (!isAuth && isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
			</>
		);
	}

	if (isAuth && !isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: rest.location?.state?.from?.pathname || "/", state: { from: rest.location } }} />
			</>
		);
	}

	// 🔒 F3 fix: gate de permissão por URL direta. Apenas usuários com
	// `requiredPermission` no `menuPermissions` (ou admin/super) acessam.
	//
	// 🐛 C8 fix: aguardar `loading=false` antes de decidir. Durante o boot,
	// `user` ainda não está hidratado e o guard redirecionaria admin por engano.
	if (isPrivate && requiredPermission && !loading && !hasMenuPermission(user, requiredPermission)) {
		return (
			<>
				<Redirect to="/" />
			</>
		);
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
